module.exports = __webpack_public_path__ + "static/media/txfb-big.8a9da720.png";